import { c as _c } from "react/compiler-runtime";
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { FOOTPRINT_FOOTER_ID } from '../../../constants';
import SecuredByFootprint from '../../secured-by-footprint';
import FooterActions from './footer-actions';
type MobileFooterProps = {
  ref: React.RefObject<HTMLDivElement | null>;
  footerVisible: boolean;
  config?: OnboardingSessionConfig;
  defaultOpen?: boolean;
  footerPosition: 'sticky' | 'relative';
  hideOnDesktop?: boolean;
};
const MobileFooter = forwardRef<HTMLDivElement, MobileFooterProps>((t0, ref) => {
  const $ = _c(13);
  const {
    footerVisible,
    config,
    defaultOpen,
    footerPosition,
    hideOnDesktop
  } = t0;
  const t1 = footerPosition === "sticky";
  const t2 = footerPosition !== "sticky";
  const t3 = !footerVisible;
  let t4;
  if ($[0] !== hideOnDesktop || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = cx("flex justify-between py-3 px-4 border-t border-tertiary bg-secondary w-full", {
      "sticky bottom-0 z-5": t1,
      "relative z-1!": t2,
      "hidden!": t3,
      "min-[900px]:hidden!": hideOnDesktop
    });
    $[0] = hideOnDesktop;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SecuredByFootprint />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== config || $[7] !== defaultOpen) {
    t6 = <FooterActions config={config} defaultOpen={defaultOpen} />;
    $[6] = config;
    $[7] = defaultOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== ref || $[10] !== t4 || $[11] !== t6) {
    t7 = <footer id={FOOTPRINT_FOOTER_ID} ref={ref} className={t4}>{t5}{t6}</footer>;
    $[9] = ref;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
});
export default MobileFooter;